<template>
  <div class="center" id="pdfDom">
    <div class="waitingcom_title">
      <el-form
        label-width="80px"
        :model="formLabelAlign"
        ref="formLabelAlign"
        :label-position="labelPosition"
      >
        <el-form-item label="考试名称：" prop="examName">
          <el-input
            v-model.trim="formLabelAlign.examName"
            placeholder="请输入考试名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="组卷模式：" prop="examModel">
          <el-select
            v-model="formLabelAlign.examModel"
            label="全部"
            @change="searchChang"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              @change="getoptions(item.value)"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试状态：" prop="examStatus">
          <el-select v-model="formLabelAlign.examStatus" @change="searchChang">
            <el-option
              v-for="item in examStatusArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间：" prop="value3">
          <div class="block">
            <el-date-picker
              @change="searchChang"
              v-model="examTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="创建开始日期"
              end-placeholder="创建结束日期"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </div>
        </el-form-item>
      </el-form>
      <div class="query_btn">
        <el-button
          type="primary"
          icon="el-icon-search"
          class="searchbtn"
          @click="searchBtn"
          >搜索</el-button
        >
        <el-button
          icon="el-icon-refresh"
          class="searchbtn sonbtn"
          @click="resetForm('formLabelAlign')"
          >重置</el-button
        >
      </div>
    </div>
    <div class="batch_box">
      <el-button @click="batchExport" v-if="$root.$hasbtn('批量导出成绩')">
        <i class="el-icon-upload"></i>批量导出成绩</el-button
      >
    </div>

    <!-- 表单内容 -->
    <div class="hos_table" v-loading="loading">
      <el-table
        :data="getData"
        ref="multipleTable"
        style="width: 100%"
        :cell-class-name="stateColor"
        :row-class-name="tableRowClassName"
        @row-click="StepsListRowClick"
        @selection-change="handleSelectionChange"
        :row-key="getRowKeyOfTarget"
        :header-cell-style="{
          'background-color': '#8FCBFF',
          color: '#333333',
          height: '60px',
        }"
      >
        <el-table-column
          type="selection"
          width="50"
          :reserve-selection="true"
        ></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            {{ scope.$index + 1 + (currentPage3 - 1) * pageSize }}
          </template>
        </el-table-column>
        <el-table-column label="考试名称" width="150" class="special">
          <template slot-scope="scope">
            {{ scope.row.ExamName }}
            <el-tooltip placement="right-start" effect="darkts">
              <div slot="content" class="bubbles_box">
                <div
                  class="bubbles_son"
                  style="color: #ffffff; background-color: #00d254"
                >
                  <p>总分:{{ scope.row.TotalScore }}分</p>
                  <p>时间:{{ scope.row.SpendTime }}分钟</p>
                </div>

                <br />
                <div
                  class="bubbles_son"
                  style="color: #ffffff; background-color: #00d254"
                >
                  <p>参考人员:{{ scope.row.StudentCount }}人</p>
                  <p>及格线:{{ scope.row.PassScore }}分</p>
                </div>
              </div>

              <i class="iconfont icon-tishi"></i>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in formColumns"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          :width="item.width"
          height="150"
          label-height="50"
          align="center"
        >
          <template v-if="item.prop === 'IsPublish'">
            <template slot-scope="scope">{{
              scope === 1 ? "1" : "2"
            }}</template>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="操作" align="center" width="406">
          <template slot-scope="scope">
            <div class="operation_box">
              <el-button
                type="text"
                size="small"
                @click.stop="resultsQuery(scope.row)"
                v-if="$root.$hasbtn('成绩查询')"
                >批改</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('发布成绩')"
                @click.stop="releaseBtn(scope.row)"
                :disabled="
                  scope.row.BeginTime > scope.row.ServerTime &&
                  scope.row.IsPublish == 1
                "
                >发布</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('导出成绩')"
                @click.stop="exportBtn(scope.row)"
                >导出成绩</el-button
              >
              <el-button
                type="text"
                size="small"
                v-if="$root.$hasbtn('导出答题详情')"
                @click.stop="exportDetails(scope.row)"
                >导出答题详情</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="reDoExam(scope.row)"
                >补考</el-button
              >
              <el-button
                type="text"
                size="small"
                @click.stop="resultsReport(scope.row)"
                >成绩报告</el-button
              >
              <!-- <button
                type="button"
                class="btn btn-primary"
                @click="getPdf('成绩报告')"
              >
                导出PDF
              </button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="foot_box">
      <div class="foot_pagetions">
        <p>共有{{ total }}条记录，当前第{{ currentPage3 }}/{{ pagesun }}页</p>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="showpageindex"
          :page-size="pageSize"
          :page-sizes="pagesizesarr"
          layout="prev, pager, next,sizes, jumper"
          :total="total"
          class="pagination"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 发布试卷弹窗 -->
    <div class="null_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="nullVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="delete_mian">
          <i class="iconfont icon-tishi1"></i>
          <p>请选择需要导出的试卷！</p>
        </div>
        <p></p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="nullVisible = false">取 消</el-button>
          <el-button type="primary" @click="nullVisible = false">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 发布试卷弹窗 -->
    <div class="everywhere">
      <el-dialog
        title="发布提示"
        :visible.sync="dialogVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="delete_mian">
          <!-- <i class="iconfont icon-tishi1"></i> -->
          <div class="mode_view">
            <el-radio-group v-model="achievement">
              <el-radio :label="0">仅发布成绩</el-radio>
              <el-radio :label="1">发布成绩和答题详情</el-radio>
            </el-radio-group>
          </div>
          <p class="p">成绩一经发布将不得修改，确定发布吗？</p>
        </div>
        <p></p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" :loading="sundflag" @click="deteRelease">
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 导出成绩 -->
    <div class="exportView">
      <el-dialog
        title="温馨提示"
        :visible.sync="exportVisible"
        width="30%"
        :close-on-click-modal="false"
      >
        <div class="delete_mian">
          <p>
            导出成绩前请留意主观题是否完成批阅且发布成绩，成绩未发布的考试无法导出答题详情。后台需要几分钟来生成您需要的试卷文件，点击确认开始生成试卷文件。
          </p>
        </div>
        <p></p>
        <span slot="footer" class="dialog-footer">
          <el-button @click="exportVisible = false">取 消</el-button>
          <el-button
            type="primary"
            @click="exportMine()"
            v-if="State == true"
            :loading="sundflag"
          >
            确 定
          </el-button>
          <el-button
            type="primary"
            @click="exportTow()"
            v-else
            :loading="sundflag"
          >
            确 定
          </el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import systemclass from "@/api/systemclassification";
import { BASEUrl } from "@/utils/request";
import jisuan from "@/utils/rem";
import loginvuex from "@/store/index";
import training from "@/api/trainingApi";
import { typeTestPaper } from "@/utils/topicImg"; // 题型图片处理
import {
  getexamList,
  exportAnswer,
  oneKeyPublishResult,
  batchExportExcel,
} from "@/api/index.js";
import qs from "qs";
export default {
  data() {
    return {
      blodData: "",
      stateArr: [], //存储开始时间和结束时间。
      getData: [],
      State: true, // false为导出答题详情弹窗确定按钮
      currentPage3: 1, //  当前页数
      pageSize: 10, //每页的条数
      pagesizesarr: [5, 10, 20, 50, 100],
      pagesun: "", //一共多少页
      total: 100,
      loading: true,
      isselecttest: "", //当前行的row
      dialogVisible: false, // 发布成绩弹窗
      exportVisible: false, // 导出成绩提示弹窗
      nullVisible: false, // 为空拦截
      multipleSelection: [], // 多选中数组
      multipleSelectionIds: [],
      multiplePaperID: [],
      multipleSelectionCount: 0,
      examName: "", // 试卷名字
      urlExamID: "", // 列表试卷名字
      deal: "",
      examNameArr: [],
      examTime: "", // 考试时间
      formLabelAlign: {
        examName: "", // 考试名称
        examModel: "", // 组卷模式
        examStatus: "", // 考试状态
        createBeginTime: "", //创建开始时间
        createEndTime: "", //创建结束时间
      },
      releaseShow: false,
      showpageindex: 1, //显示的索引盒子
      getDataCondition: {
        examName: "", // 考试名称
      },
      options: [
        {
          label: "全部",
        },
        {
          value: "unified_db",
          label: "智能组卷",
        },
        {
          value: "unified_exam",
          label: "试卷组卷",
        },
        {
          value: "sg_db",
          label: "精准组卷",
        },
        {
          value: "unified_Proportion",
          label: "权重组卷",
        },
      ],
      examStatusArr: [
        {
          label: "全部",
        },
        {
          value: "0",
          label: "待考试",
        },
        {
          value: "1",
          label: "考试中",
        },
        {
          value: "2",
          label: "考试结束",
        },
      ],
      formColumns: [
        {
          prop: "PaperModeExam",
          label: "组卷模式",
          width: jisuan(90, document.body.clientWidth),
          // width: "90px",
        },
        {
          prop: "PaperModeName",
          label: "命题方式",
          width: jisuan(100, document.body.clientWidth),
        },
        {
          prop: "BeginTime1",
          label: "考试时间",
          width: jisuan(260, document.body.clientWidth),
        },
        {
          prop: "AnIsPublish",
          label: "考试状态",
          width: jisuan(110, document.body.clientWidth),
        },
        {
          prop: "AlreadyStuCount",
          label: "已考人数",
          width: jisuan(80, document.body.clientWidth),
        },
        {
          prop: "StudentCount1",
          label: "未考人数",
          width: jisuan(80, document.body.clientWidth),
        },
        {
          prop: "CreateTime1",
          label: "创建时间",
          width: jisuan(140, document.body.clientWidth),
        },
        {
          prop: "UserName",
          label: "组卷人",
          width: jisuan(80, document.body.clientWidth),
        },
      ],
      labelPosition: "right",
      dowloadData: {},
      sundflag: false, // 发布试卷的防抖
      rowExamID: "", // 导出成绩ID
      achievement: 1, // 发布成绩模式
    };
  },
  props: ["cutcoms"],
  methods: {
    // 搜索
    searchBtn() {
      this.Buriedpoint(
        {
          code: "OnlineTest:Correcting:search",
          parent_code: "OnlineTest:Correcting",
        },
        "statetime"
      );
      this.currentPage3 = 1;
      this.loading = true;
      if (this.formLabelAlign.examName) {
        this.getDataCondition.examName = this.formLabelAlign.examName;
      } else {
        this.getDataCondition.examName = "";
      }
      this.multipleSelection = []; // 多选中数组
      this.multipleSelectionIds = [];
      this.multiplePaperID = [];
      this.$refs.multipleTable.clearSelection(); // 清除勾选状态
      this.getDatalist();
    },
    // chang搜索
    searchChang() {
      this.currentPage3 = 1;
      this.multipleSelection = []; // 多选中数组
      this.multipleSelectionIds = [];
      this.multiplePaperID = [];
      this.$refs.multipleTable.clearSelection(); // 清除勾选状态
      this.loading = true;
      if (this.examTime == null) {
        this.formLabelAlign.createBeginTime = "";
        this.formLabelAlign.createEndTime = "";
      }
      this.getDatalist();
    },
    Buriedpoint(itemt, isstate) {
      if (isstate == "statetime") {
        //次数
        let parmas = {
          type: "2",
          code: itemt.code,
          parent_code: itemt.parent_code,
          stay_start_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_end_time: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          stay_time: 1,
          ation_source: null,
          source: "khy",
          ip: null,
          userID: JSON.parse(loginvuex.state.userlist).userID,
          guid: JSON.parse(loginvuex.state.userlist).guid,
        };
        systemclass.addburied(parmas);
      } else {
        //闭环时间
        if (this.stateArr.length == 0) {
          this.stateArr[0] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        } else {
          this.stateArr[1] = this.$moment().format("YYYY-MM-DD HH:mm:ss");
          let statetime = this.$moment(new Date(this.stateArr[1])).diff(
            new Date(this.stateArr[0]),
            "seconds"
          );
          let parmas = {
            type: "2",
            code: itemt.code,
            parent_code: itemt.parent_code,
            stay_start_time: this.stateArr[0],
            stay_end_time: this.stateArr[1],
            stay_time: statetime,
            ation_source: null,
            source: "khy",
            ip: null,
            userID: JSON.parse(loginvuex.state.userlist).userID,
            guid: JSON.parse(loginvuex.state.userlist).guid,
          };
          systemclass.addburied(parmas);
          this.stateArr = [];
        }
      }
    },
    // 给每一行设置key
    getRowKeyOfTarget(row) {
      return row.ExamID;
    },
    //获取选中的optins
    getoptions(value) {
      console.log(value);
      console.log("ssss");
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 考试状态
    ChannelMerger() {
      // 组卷模式
      this.getData = this.getData.map((item) => {
        if (item.PaperMode === "unified_db") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "智能组卷";
        } else if (item.PaperMode === "random_db") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "智能组卷";
        } else if (item.PaperMode === "unified_exam") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "试卷组卷";
        } else if (item.PaperMode === "random_exam") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "试卷组卷";
        } else if (item.PaperMode === "unified_Proportion") {
          item.PaperModeName = "统一命题";
          item.PaperModeExam = "权重组卷";
        } else if (item.PaperMode === "random_Proportion") {
          item.PaperModeName = "随机命题";
          item.PaperModeExam = "权重组卷";
        } else if (item.PaperMode === "sg_db") {
          item.PaperModeName = "手动命题";
          item.PaperModeExam = "精准组卷";
        } else if (item.PaperMode === "paper") {
          item.PaperModeExam = "纸质试卷";
        } else if (item.PaperMode === "unified_difflever") {
          item.PaperModeExam = "难易度组卷";
          item.PaperModeName = "统一命题";
        } else if (item.PaperMode === "random_difflever") {
          item.PaperModeExam = "难易度组卷";
          item.PaperModeName = "随机命题";
        }
        // 创建时间转换
        // 时间拼接
        item.CreateTime1 = this.$moment(item.CreateTime).format(
          "YYYY/MM/DD HH:mm"
        );
        item.BeginTime1 =
          this.$moment(item.BeginTime).format("YYYY/MM/DD HH:mm") +
          "-" +
          this.$moment(item.EndTime).format("YYYY/MM/DD HH:mm");
        // 代考人数的计算
        item.StudentCount1 = item.StudentCount - item.AlreadyStuCount;
        if (item.StudentCount1 < 0) {
          item.StudentCount1 = 0;
        }

        // 考试状态
        if (item.BeginTime > item.ServerTime && item.IsPublish === 1) {
          this.$set(item, "AnIsPublish", "待考试");
        }
        if (
          item.BeginTime <= item.ServerTime &&
          item.IsPublish === 1 &&
          item.ServerTime < item.EndTime
        ) {
          this.$set(item, "AnIsPublish", "考试中");
        }
        if (item.ServerTime > item.EndTime && item.IsPublish === 1) {
          this.$set(item, "AnIsPublish", "考试结束");
        }
        return item;
      });
    },
    // 分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loading = true;
      this.getDatalist(); // 重新发起请求
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage3 = val;
      this.loading = true;
      this.getDatalist();
    },
    handleSelectionChange(val) {
      // 初始化全局表格多选框
      this.multipleSelectionIds = []; // 缓存好数据的试卷ID
      this.multiplePaperID = [];
      this.multipleSelection = val; // 批量删除多选状态
      this.multipleSelectionCount = 0;
      val.forEach((row) => {
        this.multipleSelectionIds.push(row.ExamID);
        this.multiplePaperID.push(row.OperatUserID);
      });
      this.multipleSelection = val;
      this.multipleSelectionCount = this.multipleSelection.length;
    },
    // 表格样式设置
    stateColor({ row, column, rowIndex, columnIndex }) {
      if (row.AnIsPublish === "考试中" && columnIndex === 6) {
        return "yellow";
      } else if (row.AnIsPublish === "考试结束" && columnIndex === 6) {
        return "red";
      } else if (row.AnIsPublish === "待考试" && columnIndex === 6) {
        return "green";
      }
    },
    // 勾选当前行激活check
    StepsListRowClick(row, column, event) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    // 重置
    resetForm(formExamin) {
      this.Buriedpoint(
        {
          code: "OnlineTest:Correcting:rest",
          parent_code: "OnlineTest:Correcting",
        },
        "statetime"
      );
      this.$refs[formExamin].resetFields();
      this.loading = true;
      this.examTime = "";
      this.showpageindex = 1;
      this.formLabelAlign.examName = "";
      this.getDataCondition.examName = "";
      this.formLabelAlign.createBeginTime = "";
      this.formLabelAlign.createEndTime = "";
      this.currentPage3 = 1;
      this.multipleSelectionIds = []; // 清除选中的状态
      this.multiplePaperID = [];
      this.multipleSelection = [];
      this.$refs.multipleTable.clearSelection(); // 清除勾选状态
      this.getDatalist();
    },
    // 导出答题详情 ===> 获取ID请求
    async exportDetails(row) {
      this.Buriedpoint(
        {
          code: "OnlineTest:Correcting:exportAnswerDetails",
          parent_code: "OnlineTest:Correcting",
        },
        "statetime"
      );
      this.$parent.examInfo = row;
      this.State = false; // 弹窗false为导出答题详情确定按钮
      this.exportVisible = true;
      return;
    },
    // 导出答题详情确定导出
    async exportTow() {
      this.sundflag = true;
      let parmas = {
        examID: this.$parent.examInfo.ExamID,
        isAnswer: 1,
        userID: JSON.parse(loginvuex.state.userlist).userID,
      };
      const Data = await exportAnswer(parmas);
      if (Data.status == 200) {
        setTimeout(() => {
          this.State = false; // 弹窗false为导出答题详情确定按钮
          this.exportVisible = true;
          const blob = new Blob([Data.data]);
          let link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.setAttribute(
            "download",
            `${this.$parent.examInfo.ExamName}.zip`
          );
          link.click();
          link = null;
          this.sundflag = false;
          this.State = true;
          this.exportVisible = false;
        }, 500);
      } else if (Data.status == 202) {
        if (!Data.headers["content-disposition"]) {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([Data.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            if (fileReader.result) {
              const msg = JSON.parse(fileReader.result);
              if (msg.status == 202) {
                this.$alert(msg.data, "温馨提示", {
                  confirmButtonText: "了解",
                  type: "warning",
                }).then(() => {
                  setTimeout(() => {
                    this.sundflag = false;
                    this.exportVisible = false;
                  }, 500);
                });
              }
            }
          };
        }
      } else {
        this.$message.error(
          "当前文件过大，后台正在生成文件，请5分钟之后再来下载"
        );
        this.sundflag = false;
        this.State = true;
        this.exportVisible = false;
      }
    },
    // 成绩查询
    resultsQuery(row) {
      localStorage.setItem("isreload", true);
      this.Buriedpoint({
        code: "OnlineTest:Correcting:scoreQuery",
        parent_code: "OnlineTest:Correcting",
      });
      sessionStorage.removeItem("queryObj"); // 重置内部查询条件
      // if(this.$route.query.examID)
      this.$parent.examInfo = row
        ? row
        : JSON.parse(sessionStorage.getItem("examInfo"));
      sessionStorage.removeItem("examInfo"); // 重置内部查询条件
      this.cutcoms(1);
      sessionStorage.setItem(
        "studRow",
        row ? row.ExamID : this.$route.query.examID
      ); // 将试卷ID存入会话存储
    },
    // 发布成绩
    releaseBtn(row) {
      this.Buriedpoint(
        {
          code: "OnlineTest:Correcting:publishedResult",
          parent_code: "OnlineTest:Correcting",
        },
        "statetime"
      );
      this.dialogVisible = true;
      this.$parent.examInfo = row;
      console.log(row);
    },
    async deteRelease() {
      this.sundflag = true;
      let params = {
        examID: this.$parent.examInfo.ExamID,
        isAnswerDetail: this.achievement, // 0:只发布成绩，1:成绩+答题详情
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid).hid,
      };
      const Data = await oneKeyPublishResult(params);
      if (Data.data.Status === 200) {
        // if (Data.status === 200) {
        this.dialogVisible = false;
        this.$message({
          message: "恭喜你，发布成功",
          type: "success",
        });
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        this.getDatalist();
      } else {
        this.$message.error(Data.data.Data);
        this.sundflag = false;
      }
    },
    // 导出成绩
    async exportBtn(row) {
      this.Buriedpoint(
        {
          code: "OnlineTest:Correcting:exportResult",
          parent_code: "OnlineTest:Correcting",
        },
        "statetime"
      );
      if (row.AnIsPublish == "待考试") {
        this.$message({
          message: "当前考试状态为待考试，不能导出成绩",
          type: "warning",
        });
      } else {
        this.State = true;
        this.exportVisible = true;
        this.isselecttest = row;
      }
    },
    // 单个导出成绩
    async exportMine() {
      this.sundflag = true;
      this.exportVisible = false;
      const a = document.createElement("a");
      a.setAttribute("download", this.dowloadData.FileName);
      if ((this.dowloadData.length = 1)) {
        a.href = `${BASEUrl.baseurOne}/api/examManage/examResultManager/OutlnExcel/${this.isselecttest.ExamID}`;
        a.click();
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        //释放URL对象所占资源
        window.URL.revokeObjectURL(a);
      } else {
        a.href = `${BASEUrl.baseurOne}/examManage/examResultManager/OutlnExcel/${this.dowloadData[0].FileName}`;
        a.click();
        setTimeout(() => {
          this.sundflag = false;
        }, 500);
        //释放URL对象所占资源
        window.URL.revokeObjectURL(a);
      }
    },
    // 批量导出成绩
    batchExport() {
      this.Buriedpoint(
        {
          code: "OnlineTest:Correcting:batchExport",
          parent_code: "OnlineTest:Correcting",
        },
        "statetime"
      );
      const ids = [];
      this.multipleSelection.map((item) => {
        ids.push({
          ExamID: item.ExamID,
          PaperID: item.PaperID,
        });
      });
      console.log(ids.length);
      if (ids.length == 0) {
        // this.$message({
        //   message: "警告，请选择需要批量导出的数据",
        //   type: "warning",
        // });
        this.nullVisible = true;
        return;
      } else {
        this.$confirm("此操作将批量导出成绩, 是否继续?", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            // 发送请求
            let params = {
              examObjList: ids,
              userID: JSON.parse(loginvuex.state.userlist).userID,
              guid: JSON.parse(loginvuex.state.userlist).guid,
              hid: JSON.parse(loginvuex.state.userlist).hid,
            };
            const Data = await batchExportExcel(params);
            console.log(Data.data);
            let content = Data.data;
            const blob = new Blob([content], {
              type: "application/application/zip",
            });
            let url = window.URL.createObjectURL(blob);
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("id", "downloadLink");
            let date =
              new Date().getFullYear() +
              "" +
              (new Date().getMonth() + 1) +
              "" +
              new Date().getDate();
            link.setAttribute("download", date + ".zip");
            document.body.appendChild(link);
            // 删除添加的a链接
            let objLink = document.getElementById("downloadLink");
            objLink.click();
            document.body.removeChild(objLink);
            // 释放内存
            //  window.URL.revokeOjbectURL(url)
            if (Data.status === 200) {
              this.$message({
                message: "成绩批量导出已发送请求，请耐心等候",
                type: "success",
              });
            }
          })
          .catch((erro) => {
            console.log(erro);
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
      // if (ids.length <= 0) return;
    },
    // 从试卷中添加考生-试卷列表
    async getDatalist() {
      if (this.examTime) {
        const time = JSON.parse(JSON.stringify(this.examTime));
        this.formLabelAlign.createBeginTime = this.$moment(time[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.formLabelAlign.createEndTime = this.$moment(time[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      let res = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        operatUserID: "",
        type: 0,
        pageIndex: this.currentPage3 - 1,
        eachPageNum: this.pageSize,
        examName: this.getDataCondition.examName, // 考试名称
        examModel: this.formLabelAlign.examModel, // 组卷模式
        examStatus: this.formLabelAlign.examStatus, // 考试状态
        createBeginTime: this.formLabelAlign.createBeginTime, //考试开始时间
        createEndTime: this.formLabelAlign.createEndTime, //考试结束时间
      };

      const Data = await getexamList(res);
      if (Data.data.Status == 200) {
        //  this.loading = false;
        this.total = Data.data.Data.count;
        this.getData = Data.data.Data.data;
        this.pagesun = Data.data.Data.pageCount;
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.ChannelMerger();
      } else {
        this.$message.error("数据获取不到");
      }
    },
    // 补考
    reDoExam: function (row) {
      this.$parent.examInfo = row;
      this.cutcoms(3);
    },
    // 成绩报告
    resultsReport(row) {
      this.$parent.examInfo = row;
      this.cutcoms(4);
    },
    async init() {
      if (this.$route.query.trainId) {
        const obj = {
          scoreId: this.$route.query.scoreId,
          type: this.$route.query.typeState,
          typeId: this.$route.query.typeId,
        };
        const { data } = await training.getTypeDetail(obj);
        if (data.Status == 200) {
          const typeTest = typeTestPaper(data.Data.PaperMode);
          data.Data.PaperModeName = typeTest.PaperModeName;
          data.Data.PaperModeExam = typeTest.PaperModeExam;
          this.$parent.examInfo = data.Data;
          if (this.$route.query.type == 0) {
            // 批改
            localStorage.setItem("isreload", true);
            sessionStorage.removeItem("queryObj"); // 重置内部查询条件
            sessionStorage.removeItem("examInfo"); // 重置内部查询条件
            this.cutcoms(1);
            sessionStorage.setItem(
              "studRow",
              data.Data ? data.Data.ExamID : this.$route.query.examID
            ); // 将试卷ID存入会话存储
          } else if (this.$route.query.type == 1) {
            // 补考
            this.cutcoms(3);
          } else {
            // 成绩报告
            this.cutcoms(4);
          }
        } else {
          this.$message.error(data.Data);
        }
      }
    },
  },
  created() {
    this.stateArr = [];
    this.getDatalist();
    this.init();
    if (this.$route.query.examID) {
      this.resultsQuery();
    }
    localStorage.removeItem("isreload");
  },
  mounted() {
    if (
      /Safari/.test(navigator.userAgent) &&
      !/Chrome/.test(navigator.userAgent)
    ) {
      //Safari浏览器兼容性问题。
      this.$refs.multipleTable.$el.style.display = "table-cell";
    }
  },
};
</script>

<style lang="scss" scoped>
.center {
  height: 100%;
  width: 100%;
  min-width: 1650px;
  background-color: rgb(255, 255, 255);
}
.waitingcom_title {
  height: 81px;
  padding: 24px 24px 16px 10px;
  border-bottom: 1px solid #f8f8f8;
  display: flex;
  ::v-deep .el-form-item__label {
    margin-left: 24px;
    width: 87px !important;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
  ::v-deep .el-form-item__content {
    margin-left: 115px !important;
  }
}
.el-form {
  display: flex;
  ::v-deep .el-input > .el-input__inner {
    width: 168px;
  }
}
.query_btn {
  margin: 0;
  display: flex;
  .el-button {
    width: 88px;
    height: 40px;
    margin-left: 24px;
  }
}
.hos_table {
  margin-top: 24px;
  padding: 0px 24px;
  min-height: 560px;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(12) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
.sonbtn {
  border: 1px solid #d9d9d9 !important;
  color: #999999;
}
// 分页
.foot_box {
  position: relative;
  height: 86px;
}
.foot_pagetions {
  display: flex;
  position: absolute;
  right: 16px;
  bottom: 30px;
  p {
    text-align: center;
    line-height: 32px;
    font-family: 微软雅黑;
    color: #949494;
  }
  span {
    line-height: 32px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    b {
      color: #ff0000;
    }
  }
}
.pagination {
  ::v-deep .el-pager {
    li {
      border: 1px solid #d9d9d9;
      margin-right: 8px;
      &.active {
        color: #ffffff;
        background-color: #409eff;
        border: none;
      }
    }
  }
}
::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
::v-deep .el-range-separator {
  color: #eeeeee !important;
}
::v-deep .el-table .redtwo .cell {
  color: #ff0000 !important;
}
::v-deep .el-table .gray .cell {
  color: #aaaaaa !important;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep .el-table th {
  width: 100%;
  height: 60px;
  background: #cce7ff;
  color: #333333;
  opacity: 1;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(12) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}

::v-deep .el-table td div:nth-child(1) {
  text-align: center;
}

.operation_box {
  .el-button {
    font-size: 16px;
  }
}
::v-deep .el-table .red .cell {
  color: #ff0000 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ff0000;
  }
}
::v-deep .el-table .yellow .cell {
  color: #ffa200 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #ffa200;
  }
}
::v-deep .el-table .green .cell {
  color: #00d254 !important;
  &::before {
    content: "●";
    width: 20px;
    display: inline-block;
    color: #00d254;
  }
}
.icon-tishi {
  display: inline-block;
  // transform: translate(-6px, -5px) scale(0.6);
  &::before {
    color: #cad8d0;
    display: inline-block;
  }
}

.bubbles_box {
  .bubbles_son {
    display: flex !important;
    p {
      flex: 1;
      width: 80px;
    }
  }
}
.null_view {
  ::v-deep .el-dialog {
    width: 300px !important;
    min-height: 200px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .delete_mian {
    display: flex;
    box-sizing: border-box;
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: left;
      font-size: 15px;
    }
  }
}
.everywhere {
  ::v-deep .el-dialog {
    width: 441px !important;
    min-height: 188px !important;
    border-radius: 5px 5px 0px 0px;
  }
  .delete_mian {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .el-radio-group {
      display: flex;
    }
    ::v-deep .el-radio__label {
      font-size: 16px;
    }
    i {
      display: inline-block;
      font-size: 16px !important;
      color: #ffc664;
      text-align: center;
      margin-right: 10px;
      transform: translateY(4px);
    }
    p {
      text-align: center;
      font-size: 14px !important;
      color: #ababab;
      margin-top: 12px;
    }
  }
}
.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 26px;
  button:nth-child(1) {
    margin-right: 50px;
  }
}
::v-deep .el-dialog__footer {
  padding: 0;
}
::v-deep.el-dialog__header {
  padding: 16px 20px 10px;
}
::v-deep .el-dialog__header {
  height: 55px;
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  background: linear-gradient(
    180deg,
    #64b5ff 0%,
    rgba(199, 228, 255, 1) 100%
  ) !important;
}
.el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.exportView {
  ::v-deep .el-dialog {
    width: 340px !important;
    min-height: 220px !important;
    line-height: 24px;
    border-radius: 5px 5px 0px 0px;
  }
}
.batch_box {
  padding: 0px 24px;
  margin-top: 24px;
  .el-button {
    width: 141px;
    height: 40px;
    color: #ffffff;
    background: #64b5ff;
  }
  span > i {
    font-size: 14px !important;
    margin-right: 5px;
  }
}
.mode_view {
  display: flex;
  justify-content: center;
  align-items: center;
  > p {
    font-size: 18px !important;
    font-weight: bolder;
    margin-right: 8px;
  }
}
</style>
<style lang="scss" >
.el-tooltip__popper.is-dark {
  background: #00d254;
  > :nth-child(2) {
    border-right: 6px solid #00d254 !important;
    &::after {
      border: none;
    }
  }
}
</style>
